module.exports = __webpack_public_path__ + "img/kp.767e8d99.svg";